export const SILKTIDE_ASSET_VERSION = '20260603-9';